import { db } from './config';
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
  query,
  orderBy,
  serverTimestamp
} from 'firebase/firestore';

// Team Tasks
export const getTeamTasks = async () => {
  try {
    const q = query(collection(db, 'teamTasks'), orderBy('createdAt', 'asc'));
    const querySnapshot = await getDocs(q);
    const tasks = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    return { success: true, tasks };
  } catch (error) {
    console.error('Error getting team tasks:', error);
    return { success: false, error: error.message, tasks: [] };
  }
};

export const createTeamTask = async (taskData) => {
  try {
    const docRef = await addDoc(collection(db, 'teamTasks'), {
      ...taskData,
      createdAt: serverTimestamp()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating team task:', error);
    return { success: false, error: error.message };
  }
};

export const deleteTeamTask = async (taskId) => {
  try {
    await deleteDoc(doc(db, 'teamTasks', taskId));
    return { success: true };
  } catch (error) {
    console.error('Error deleting team task:', error);
    return { success: false, error: error.message };
  }
};

export const toggleTaskCompletion = async (taskId, completed, completedBy) => {
  try {
    await updateDoc(doc(db, 'teamTasks', taskId), {
      completed,
      completedBy,
      completedAt: completed ? serverTimestamp() : null
    });
    return { success: true };
  } catch (error) {
    console.error('Error toggling task completion:', error);
    return { success: false, error: error.message };
  }
};

// Team Messages
export const getTeamMessages = async () => {
  try {
    const q = query(collection(db, 'teamMessages'), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    const messages = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    return { success: true, messages };
  } catch (error) {
    console.error('Error getting team messages:', error);
    return { success: false, error: error.message, messages: [] };
  }
};

export const createTeamMessage = async (messageData) => {
  try {
    const docRef = await addDoc(collection(db, 'teamMessages'), {
      ...messageData,
      createdAt: serverTimestamp()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating team message:', error);
    return { success: false, error: error.message };
  }
};

export const deleteTeamMessage = async (messageId) => {
  try {
    await deleteDoc(doc(db, 'teamMessages', messageId));
    return { success: true };
  } catch (error) {
    console.error('Error deleting team message:', error);
    return { success: false, error: error.message };
  }
};

// Team Documents
export const getTeamDocuments = async () => {
  try {
    const q = query(collection(db, 'teamDocuments'), orderBy('uploadedAt', 'desc'));
    const querySnapshot = await getDocs(q);
    const documents = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    return { success: true, documents };
  } catch (error) {
    console.error('Error getting team documents:', error);
    return { success: false, error: error.message, documents: [] };
  }
};

export const createTeamDocument = async (documentData) => {
  try {
    const docRef = await addDoc(collection(db, 'teamDocuments'), {
      ...documentData,
      uploadedAt: serverTimestamp()
    });
    return { success: true, id: docRef.id };
  } catch (error) {
    console.error('Error creating team document:', error);
    return { success: false, error: error.message };
  }
};

export const deleteTeamDocument = async (documentId) => {
  try {
    await deleteDoc(doc(db, 'teamDocuments', documentId));
    return { success: true };
  } catch (error) {
    console.error('Error deleting team document:', error);
    return { success: false, error: error.message };
  }
};
